(function () {
  var STORAGE_KEY = 'unrushed_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* localStorage unavailable (private browsing, quota) — wishlist just won't persist */
    }
    updateCount(handles.length);
  }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setWishlist(list);
    syncButtons(handle, idx === -1);
    return idx === -1;
  }

  function syncButtons(handle, saved) {
    document.querySelectorAll('[data-wishlist-toggle][data-product-handle="' + handle + '"]').forEach(function (btn) {
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', String(saved));
    });
  }

  function syncAllButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var saved = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', String(saved));
    });
  }

  function updateCount(count) {
    if (typeof count !== 'number') count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function formatPrice(cents) {
    try {
      return (cents / 100).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
      });
    } catch (e) {
      return '$' + Math.round(cents / 100);
    }
  }

  function renderDrawer() {
    var container = document.querySelector('[data-wishlist-items]');
    var emptyState = document.querySelector('[data-wishlist-empty]');
    if (!container) return;

    var handles = getWishlist();

    if (handles.length === 0) {
      container.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    container.innerHTML = '<p class="unrushed-wishlist__loading">Cargando…</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);

      if (valid.length === 0) {
        container.innerHTML = '';
        if (emptyState) emptyState.hidden = false;
        return;
      }

      container.innerHTML = valid
        .map(function (p) {
          var image = p.featured_image || (p.media && p.media[0] && p.media[0].src) || '';
          return (
            '<div class="unrushed-wishlist__item">' +
            '<a href="' +
            p.url +
            '" class="unrushed-wishlist__item-media">' +
            (image ? '<img src="' + image + '&width=200" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="unrushed-wishlist__item-info">' +
            '<a href="' +
            p.url +
            '" class="unrushed-wishlist__item-title">' +
            p.title +
            '</a>' +
            '<span class="unrushed-wishlist__item-price">' +
            formatPrice(p.price) +
            '</span>' +
            '</div>' +
            '<button type="button" class="unrushed-wishlist__item-remove" data-wishlist-toggle data-product-handle="' +
            p.handle +
            '" aria-label="Quitar de favoritos">&times;</button>' +
            '</div>'
          );
        })
        .join('');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggle(handle);
    renderDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncAllButtons();
    updateCount();
  });

  document.addEventListener('unrushed:wishlist:open', renderDrawer);

  window.UnrushedWishlist = { getWishlist: getWishlist, toggle: toggle, isSaved: isSaved };
})();
